/* globals process */
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { api } from "../../_services";
import { history } from "../../_helpers";
import {
  getSensorData,
  sensorId,
  filteredSensorDataList,
  sidebarOff,
  pageDevices,
  modalAlert,
  setTelemetryAlertData
} from "../../_actions";
import {
  form,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  HelpBlock,
  Button
} from "react-bootstrap";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import LineGraph from "../LineGraph";
import DataMap from "../DataMap";
import Datetime from "react-datetime";
import FontAwesome from "react-fontawesome";
import _ from "lodash";
import Select from "react-select";
import "react-select/dist/react-select.css";
import "./index.css";
import "../../react_datetime.css";

const today = new Date();
const initialStartDate = new Date(new Date().setDate(today.getDate() - 1));

class ViewDevicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphLoading: true,
      buttonSubmitted: false,
      filtered: false,
      filterOpen: false,
      telemetryTypeInput: "",
      seriesTypeInput: "",
      timeRangeInput: "day",
      comparatorInput: "",
      aggregationTypeInput: "",
      aggregationPeriodInput: "",
      defaultTelemetryTypeId: "",
      defaultSeriesId: "",
      defaultAggregationType: "",
      defaultAggregationPeriod: "",
      startDate: initialStartDate.toISOString(),
      startDateTo: initialStartDate,
      endDate: today.toISOString(),
      endDateTo: today,
      location: [],
      sensorDataList: [],
      telemetrySets: [],
      seriesList: [],
      timeRangeList: [
        { id: 0, time_range_id: "hour", time_range_type: "Last Hour (live)" },
        { id: 1, time_range_id: "day", time_range_type: "Last Day (live)" },
        { id: 2, time_range_id: "week", time_range_type: "Last Week (live)" },
        { id: 3, time_range_id: "range", time_range_type: "Custom Range" }
      ],
      reloadTimer: null,
      aggregationTypeList: [],
      aggregationPeriodList: [],
      downloadLink: "",
      filteredTelemetrylist: [],
      selectedTelemetry: null,
      currentDevicePageType: false
    };
  }

  componentDidMount = () => {
    this.props.sidebarOff();
    if (this.props.match.params !== null) {
      const deviceId = this.props.match.params.deviceId;
      this.props.sensorId(deviceId);
      if (this.props.configList) {
        this.getDeviceDetails(this.props.match.params.deviceId);
      }
    }
    //set current page to devices
    this.props.pageDevices();
    let currentDevicePageType = localStorage.getItem("currentDevicePageType");
    if (currentDevicePageType) {
      currentDevicePageType = JSON.parse(currentDevicePageType);
    }
    if (
      currentDevicePageType &&
      currentDevicePageType.list !== this.state.currentDevicePageType
    ) {
      this.setState(() => {
        return {
          currentDevicePageType: currentDevicePageType.list
        };
      });
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      JSON.stringify(this.props.configList) !==
      JSON.stringify(nextProps.configList)
    ) {
      this.getDeviceDetails(this.props.match.params.deviceId);
    }
  };

  componentWillUnmount = () => {
    // clear the interval on unmount.
    clearInterval(this.state.reloadTimer);
  };

  getStatusName = val => {
    if (
      this.props.configList === undefined ||
      this.props.configList.device_statuses.length < 1
    ) {
      return null;
    }

    let device_status;
    this.props.configList.device_statuses.forEach(function(item) {
      if (val === item.status) {
        device_status = item;
      }
    });
    return device_status.display_name;
  };

  getDeviceDetails = id => {
    const url = "/api/v1/devices/" + id + "/";
    const errorMsg = "Unable to retrieve the device details.";
    api
      .getFetch(url, "", this.props.user.token, errorMsg)
      .then(json => {
        //set the device details to the state
        //set the telemetry boolean check value for managing the rendering of the page
        this.setState(() => {
          return {
            deviceDetails: json,
            telemetryCheck: json.telemetry_sets.length > 0 ? true : false,
            startDate: initialStartDate.toISOString(),
            startDateTo: initialStartDate,
            endDate: today.toISOString(),
            endDateTo: today
          };
        });
        return json;
      })
      .then(json => {
        this.setTelemetryType(json);
        return json;
      })
      //filter the series. aggregation type and the aggregation period lists based on the defualt telemetry type
      .then(json => {
        if (json.telemetry_sets.length > 0) {
          this.filterSeries(this.state.telemetryTypeInput);
          this.filterAggregationType(this.state.telemetryTypeInput);
          this.filterAggregationPeriod(this.state.telemetryTypeInput);
        }
        return json;
      })
      // get the sensor data based on the current params
      .then(json => {
        if (json.telemetry_sets.length > 0) {
          this.getSensorDataList(this.props.match.params.deviceId);
        }
      });
  };

  /* Method to filter the aggregagtion type based on the selected telemetry type */
  filterAggregationType = selectedTelemetryType => {
    const tmpaggregationTypes = [];
    const filteredTypeItem = this.props.configList.telemetry_types.filter(
      item => {
        return item.type_id.search(selectedTelemetryType) !== -1;
      }
    );

    tmpaggregationTypes.push({
      id: 0,
      aggregation_type: "None",
      aggregation_type_id: ""
    });

    if (filteredTypeItem.length > 0) {
      if (filteredTypeItem[0].aggregation_types.length > 0) {
        for (let i = 0; i < filteredTypeItem[0].aggregation_types.length; i++) {
          tmpaggregationTypes.push({
            id: i + 1,
            aggregation_type: filteredTypeItem[0].aggregation_types[i].name,
            aggregation_type_id:
              filteredTypeItem[0].aggregation_types[i].type_id
          });
        }
      }
    }
    // set the filtered data
    this.setState(() => {
      return {
        defaultAggregationType: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.aggregation_type_id
          : "",
        aggregationTypeInput: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.aggregation_type_id
          : "",
        aggregationTypeList: tmpaggregationTypes
      };
    });
  };

  /* Method to filter the aggregagtion period based on the selected telemetry type */
  filterAggregationPeriod = selectedTelemetryType => {
    const tmpaggregationperiod = [];
    const filteredTypeItem = this.props.configList.telemetry_types.filter(
      item => {
        return item.type_id.search(selectedTelemetryType) !== -1;
      }
    );

    tmpaggregationperiod.push({
      id: 0,
      aggregation_period: "None",
      aggregation_period_id: ""
    });

    if (filteredTypeItem.length > 0) {
      if (filteredTypeItem[0].aggregation_periods.length > 0) {
        for (
          let i = 0;
          i < filteredTypeItem[0].aggregation_periods.length;
          i++
        ) {
          tmpaggregationperiod.push({
            id: i + 1,
            aggregation_period: filteredTypeItem[0].aggregation_periods[i].name,
            aggregation_period_id:
              filteredTypeItem[0].aggregation_periods[i].period_id
          });
        }
      }
    }
    // set the filtered data
    this.setState(() => {
      return {
        defaultAggregationPeriod: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.aggregation_period_id
          : "",
        aggregationPeriodInput: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.aggregation_period_id
          : "",
        aggregationPeriodList: tmpaggregationperiod
      };
    });
  };

  /* Method to filter the series based on the selected telemetry type */
  filterSeries = selectedTelemetryType => {
    const tmpSeriesTypes = [];
    const filteredTypeItem = this.props.configList.telemetry_types.filter(
      item => {
        return item.type_id.search(selectedTelemetryType) !== -1;
      }
    );

    if (filteredTypeItem.length > 0) {
      if (filteredTypeItem[0].series_list.length > 0) {
        for (let i = 0; i < filteredTypeItem[0].series_list.length; i++) {
          tmpSeriesTypes.push({
            id: i,
            series_type: filteredTypeItem[0].series_list[i].short_name,
            series_id: filteredTypeItem[0].series_list[i].series_id
          });
        }
      }
    }

    // set the filtered data
    this.setState(() => {
      return {
        defaultSeriesId: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.series_id
          : tmpSeriesTypes[0].series_id,
        seriesTypeInput: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.series_id
          : tmpSeriesTypes[0].series_id,
        seriesList: tmpSeriesTypes
      };
    });
  };

  setTelemetryType = tempList => {
    if (!tempList) {
      return;
    }

    const tmpTypes = [];
    if (tempList.telemetry_sets.length > 0) {
      _.each(tempList.telemetry_sets, value => {
        const foundItem = _.find(
          this.props.configList.telemetry_types,
          item => {
            return item.type_id.search(value.telemetry_type_id) !== -1;
          }
        );

        tmpTypes.push({
          id: tempList.telemetry_sets.indexOf[value],
          telemetry_type: foundItem.name,
          telemetry_type_id: foundItem.type_id
        });
      });

      this.setTheInitialFormInputFields(tmpTypes);
      this.setTelemetryLocation(tempList.location);
    }
  };

  /* Method to handle the change in aggregation type */
  onChangeAggregationType = e => {
    const val = e.aggregation_type_id;
    this.setState(() => {
      return { aggregationTypeInput: val, buttonSubmitted: false };
    });
  };

  /* Method to handle the change in aggregation period */
  onChangeAggregationPeriod = e => {
    const val = e.aggregation_period_id;
    this.setState(() => {
      return { aggregationPeriodInput: val, buttonSubmitted: false };
    });
  };

  /* Method to handle the change in telemetry type */
  onChangeTelemetryType = e => {
    const val = e.telemetry_type_id;
    this.setState(
      () => {
        return {
          buttonSubmitted: false,
          telemetryTypeInput: val,
          aggregationTypeInput: "",
          aggregationPeriodInput: "",
          startDate: initialStartDate.toISOString(),
          startDateTo: initialStartDate,
          endDate: today.toISOString(),
          endDateTo: today
        };
      },
      () => {
        // get new data based on the selected telemetry type
        //this.getSensorDataList(this.props.match.params.deviceId);
      }
    );
    this.filterSeries(val);
    this.filterAggregationType(val);
    this.filterAggregationPeriod(val);
  };

  /* Method to handle the change in series type */
  onChangeSeriesType = e => {
    const val = e.series_id;
    this.setState(() => {
      return {
        seriesTypeInput: val,
        buttonSubmitted: false
      };
    });
    const tmpFilteredData = [];
    tmpFilteredData.push(this.state.sensorDataList[0]);
    for (let i = 0; i < this.state.sensorDataList.length; i++) {
      if (this.state.sensorDataList[i].id === val) {
        tmpFilteredData.push(this.state.sensorDataList[i]);
      }
    }

    this.setState(() => {
      return {
        filteredTelemetrylist: tmpFilteredData
      };
    });
  };

  onChangetimeRange = e => {
    const val = e.time_range_id;
    this.setState(() => {
      return {
        timeRangeInput: val
      };
    });
  };

  setReloadTimer = (params, id, timeRangeInput) => {
    if (this.state.reloadTimer) {
      clearInterval(this.state.reloadTimer);
    }
    const reload = this.getDataFromApi;
    const reloadTimer = setInterval(function() {
      reload(params, id, timeRangeInput);
    }, 60000);
    this.setState({ reloadTimer: reloadTimer });
  };

  getDataFromApi = (params, id, timeRangeInput) => {
    switch (timeRangeInput) {
    case "hour":
      params.end_time = moment().toISOString();
      params.start_time = moment()
          .subtract(1, "hours")
          .toISOString();
      break;
    case "day":
      params.end_time = moment().toISOString();
      params.start_time = moment()
          .subtract(1, "days")
          .toISOString();
      break;
    case "week":
      params.end_time = moment().toISOString();
      params.start_time = moment()
          .subtract(1, "weeks")
          .toISOString();
      break;
    default:
      break;
    }

    const url = "/api/v1/devices/" + id + "/telemetry/";
    const errorMsg = "Unable to get the telemetry data.";
    api
      .getFetch(url, params, this.props.user.token, errorMsg)
      .then(json => {
        this.props.getSensorData(json.telemetry_sets);
        this.props.setTelemetryAlertData(json.alert_traces);
        this.setState(() => {
          return {
            sensorDataList: json.telemetry_sets[0].columns,
            dataTruncated: json.telemetry_sets[0].truncated
          };
        });
      })
      .then(() => {
        this.filterSensorData();
      });
  };

  /* Validation for Aggregation Type input.
  It should always have some value if aggregation period is selected */
  getValidationStateForAggrType = () => {
    if (
      this.state.buttonSubmitted &&
      !this.state.aggregationTypeInput &&
      this.state.aggregationPeriodInput
    ) {
      return "error";
    } else {
      return null;
    }
  };

  /* Validation for end datetime
  It should always be greater than the start date */
  checkEndDate = () => {
    if (
      this.state.buttonSubmitted &&
      Date.parse(this.state.startDateTo) > Date.parse(this.state.endDateTo)
    ) {
      return "error";
    } else {
      return null;
    }
  };

  /* Validation for Aggregation Period input.
  It should always have some value if aggregation type is selected */
  getValidationStateForAggrPeriod = () => {
    if (
      this.state.buttonSubmitted &&
      this.state.aggregationTypeInput &&
      !this.state.aggregationPeriodInput
    ) {
      return "error";
    } else {
      return null;
    }
  };

  /* Handle the change in start date */
  handleStartDate = e => {
    this.setState(
      () => {
        return {
          startDate: e._d ? e._d.toISOString() : "",
          startDateTo: e._d ? e._d : "",
          buttonSubmitted: false
        };
      },
      () => {
        //this.getSensorDataList(this.props.match.params.deviceId);
      }
    );
  };

  /* Handle the change in end date */
  handleEndDate = e => {
    this.setState(
      () => {
        return {
          endDate: e._d ? e._d.toISOString() : "",
          endDateTo: e._d ? e._d : "",
          buttonSubmitted: false
        };
      },
      () => {
        //this.getSensorDataList(this.props.match.params.deviceId);
      }
    );
  };

  checkForFormError = () => {
    if (
      this.getValidationStateForAggrType() ||
      this.getValidationStateForAggrPeriod() ||
      this.checkEndDate()
    ) {
      this.setState(() => {
        return {
          formError: true,
          graphLoading: false
        };
      });
    } else {
      this.setState(() => {
        return {
          formError: false
        };
      });
    }
  };

  filterDeviceData = () => {
    this.setState(
      () => {
        return {
          buttonSubmitted: true,
          filtered: true,
          graphLoading: true
        };
      },
      () => {
        this.checkForFormError();
        this.openFilter(false);
        this.getSensorDataList(this.props.match.params.deviceId);
      }
    );
  };

  /* Method to download the data in csv format */
  downloadData = () => {
    const url = new URL(
        process.env.REACT_APP_API_HOST +
          "/api/v1/devices/" +
          this.props.match.params.deviceId +
          "/telemetry/"
      ),
      params = {
        telemetry_types: this.state.telemetryTypeInput,
        aggregation_type: this.state.aggregationTypeInput,
        aggregation_period: this.state.aggregationPeriodInput,
        start_time: this.state.startDate,
        end_time: this.state.endDate,
        max_records: 10000,
        export_format: "csv"
      };
    Object.keys(params).forEach(key =>
      url.searchParams.append(key, params[key])
    );

    const finalUrl =
      "/api/v1/devices/" +
      this.props.match.params.deviceId +
      "/telemetry/" +
      url.search;
    this.getDownloadLink({
      url: finalUrl
    });
  };

  /* Method to get the download link */
  getDownloadLink = opts => {
    const url = "/api/v1/sign-url/";
    const errorMsg = "Unable to download.";
    api.postFetch(url, opts, this.props.user.token, errorMsg).then(json => {
      if (json) {
        window.open(json);
      }
    });
  };

  setTheInitialFormInputFields = list => {
    this.setState(() => {
      return {
        defaultTelemetryTypeId: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.telemetry_type_id
          : list[0].telemetry_type_id,
        telemetryTypeInput: this.state.selectedTelemetry
          ? this.state.selectedTelemetry.telemetry_type_id
          : list[0].telemetry_type_id,
        telemetrySets: list
      };
    });
  };

  setTelemetryLocation = location => {
    if (!location) {
      return;
    }

    this.setState(() => {
      return {
        location: [location.longitude, location.latitude]
      };
    });
  };

  /* Method to get the telemetry data */
  getSensorDataList = id => {
    const startDate = Date.parse(this.state.startDate);
    const endDate = Date.parse(this.state.endDate);

    // TODO: Move to a proper validation function
    if (startDate && endDate && endDate < startDate) {
      return;
    }

    const params = {
      telemetry_types: this.state.telemetryTypeInput,
      aggregation_type: this.state.aggregationTypeInput,
      aggregation_period: this.state.aggregationPeriodInput,
      start_time: this.state.startDate,
      end_time: this.state.endDate,
      max_records: 10000,
      include_alert_traces: true
    };

    if (
      (this.state.aggregationTypeInput && this.state.aggregationPeriodInput) ||
      (!this.state.aggregationTypeInput && !this.state.aggregationPeriodInput)
    ) {
      if (this.state.timeRangeInput === "range") {
        if (this.state.reloadTimer) {
          clearInterval(this.state.reloadTimer);
        }
      } else {
        this.setReloadTimer(params, id, this.state.timeRangeInput);
      }
      this.getDataFromApi(params, id, this.state.timeRangeInput);
    }
  };

  /* Method to filter the telemetry data */
  filterSensorData = () => {
    const tmpFilteredData = [];
    tmpFilteredData.push(this.state.sensorDataList[0]);
    if (this.state.seriesTypeInput) {
      for (let i = 0; i < this.state.sensorDataList.length; i++) {
        if (this.state.sensorDataList[i].id === this.state.seriesTypeInput) {
          tmpFilteredData.push(this.state.sensorDataList[i]);
        }
      }
    } else {
      tmpFilteredData.push(this.state.sensorDataList[1]);
    }

    this.setState(
      () => {
        return {
          filteredTelemetrylist: tmpFilteredData,
          graphLoading: false
        };
      },
      () => {
        this.setFilteredTelemetryData();
      }
    );
  };

  setFilteredTelemetryData = () => {
    this.props.filteredSensorDataList(this.state.filteredTelemetrylist);
  };

  renderBackToDevicesBtn = () => {
    return (
      <a className="link" onClick={history.goBack}>
        <FontAwesome name="arrow-left" size="lg" /> Back
      </a>
    );
  };

  renderTitlePanel = deviceDetails => {
    if (!deviceDetails) {
      return null;
    }

    return (
      <div>
        <div className="mainTitle">
          <div className="breadCrumb">{this.renderBackToDevicesBtn()}</div>
          <h1>{deviceDetails.name}</h1>
          <h5>
            <span className="device-datum">ID:</span>
            {deviceDetails.device_id}
          </h5>
        </div>
      </div>
    );
  };

  renderTheDeviceLocationOnMap = deviceDetails => {
    if (!deviceDetails.location) {
      return (
        <div className="emptyCon">
          <div className="emptyIntCon text-center">
            <div className="paddingBox">
              <div className="icon-holder">
                <FontAwesome name="exclamation-circle" size="5x" />
              </div>
              This device does not have a location.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <DataMap
          type="device"
          location={
            deviceDetails.location !== null
              ? [
                deviceDetails.location.longitude,
                deviceDetails.location.latitude
              ]
              : []
          }
          status={deviceDetails.status}
          icon={deviceDetails.icon}
        />
      </div>
    );
  };

  getPrecincts = precincts => {
    if (precincts.length > 0)
      return (
        <span>
          {precincts.map(function(item, i) {
            return (
              <span key={i}>
                {i > 0 ? ", " : null}
                {item.name}
              </span>
            );
          })}
        </span>
      );
    else {
      return <span>-</span>;
    }
  };

  getSensorType = disciplines => {
    if (disciplines.length > 0)
      return (
        <span>
          {disciplines.map(function(item, i) {
            return (
              <span key={i}>
                {i > 0 ? ", " : null}
                {item.name}
              </span>
            );
          })}
        </span>
      );
    else {
      return <span>-</span>;
    }
  };

  openFilter = opened => {
    if (opened) {
      this.setState(() => {
        return {
          filterOpen: true
        };
      });
    } else {
      this.setState(() => {
        return {
          filterOpen: false
        };
      });
    }
  };

  renderStatus = item => {
    // Unmonitored locations shouldn't have a status displayed at all
    if (item.status === "unmonitored") {
      return "";
    } else {
      return (
        <div className="device-status">
          <FontAwesome
            className={"fa-xs icon-tab status-" + item.status}
            name="circle"
          />
          <span className={"status-" + item.status}>
            {this.getStatusName(item.status)}
          </span>
        </div>
      );
    }
  };

  resetFormFields = () => {
    this.setState(() => {
      return {
        filtered: false,
        graphLoading: true,
        formError: false
      };
    });
    this.getDeviceDetails(this.props.match.params.deviceId);
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a
          className="pull-right reset-button"
          onClick={() => this.resetFormFields()}
        >
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderGraphFilter = () => {
    const {
      telemetrySets,
      seriesList,
      aggregationTypeList,
      aggregationPeriodList,
      timeRangeList
    } = this.state;

    return (
      <div className="filter-column">
        <form>
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>Telemetry Type</ControlLabel>
            <Select
              name="telemetryTypeInput"
              value={this.state.telemetryTypeInput}
              onChange={this.onChangeTelemetryType}
              valueKey="telemetry_type_id"
              labelKey="telemetry_type"
              options={telemetrySets}
              clearable={false}
            />
          </FormGroup>
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>Series</ControlLabel>
            <Select
              name="seriesTypeInput"
              value={this.state.seriesTypeInput}
              onChange={this.onChangeSeriesType}
              valueKey="series_id"
              labelKey="series_type"
              options={seriesList}
              clearable={false}
            />
          </FormGroup>
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>Time Range</ControlLabel>
            <Select
              name="timeRangeInput"
              value={this.state.timeRangeInput}
              onChange={this.onChangetimeRange}
              valueKey="time_range_id"
              labelKey="time_range_type"
              options={timeRangeList}
              clearable={false}
            />
          </FormGroup>
          {this.state.timeRangeInput === "range" && (
            <div>
              <FormGroup>
                <ControlLabel>Start Date</ControlLabel>
                <Datetime
                  dateFormat="DD-MM-YYYY"
                  timeFormat="hh:mm A"
                  onChange={this.handleStartDate}
                  defaultValue={this.state.startDate}
                  value={this.state.startDateTo}
                />
              </FormGroup>
              <FormGroup validationState={this.checkEndDate()}>
                <ControlLabel>End Date</ControlLabel>
                <Datetime
                  dateFormat="DD-MM-YYYY"
                  timeFormat="hh:mm A"
                  onChange={this.handleEndDate}
                  defaultValue={this.state.endDate}
                  value={this.state.endDateTo}
                />
                {this.checkEndDate() ? (
                  <HelpBlock>
                    End date must be greater than start date.
                  </HelpBlock>
                ) : null}
              </FormGroup>
            </div>
          )}
          <FormGroup
            controlId="formControlsSelect"
            validationState={this.getValidationStateForAggrType()}
          >
            <ControlLabel>Aggregation Type</ControlLabel>
            <Select
              name="aggregationTypeInput"
              value={this.state.aggregationTypeInput}
              onChange={this.onChangeAggregationType}
              valueKey="aggregation_type_id"
              labelKey="aggregation_type"
              options={aggregationTypeList}
              clearable={false}
            />
            {this.getValidationStateForAggrType() ? (
              <HelpBlock>Please select an aggregation type.</HelpBlock>
            ) : null}
          </FormGroup>
          <FormGroup
            controlId="formControlsSelect"
            validationState={this.getValidationStateForAggrPeriod()}
          >
            <ControlLabel>Aggregation Period</ControlLabel>
            <Select
              name="aggregationPeriodInput"
              value={this.state.aggregationPeriodInput}
              onChange={this.onChangeAggregationPeriod}
              valueKey="aggregation_period_id"
              labelKey="aggregation_period"
              options={aggregationPeriodList}
              clearable={false}
            />
            {this.getValidationStateForAggrPeriod() ? (
              <HelpBlock>Please select an aggregation period.</HelpBlock>
            ) : null}
          </FormGroup>
          <div className="buttonContainer">
            <Button
              className="btn-cancel"
              bsStyle="default"
              onClick={() => this.openFilter(false)}
            >
              Cancel
            </Button>
            <Button
              className="btn-filter"
              bsStyle="primary"
              onClick={() => this.filterDeviceData()}
            >
              Filter
            </Button>
          </div>
        </form>
      </div>
    );
  };

  renderDeviceGraph = () => {
    const { telemetryCheck, sensorDataList, deviceDetails } = this.state;

    if (this.state.graphLoading) {
      return (
        <div className="empty-graph">
          <div className="loading2" />
        </div>
      );
    }

    if (!telemetryCheck) {
      return (
        <div className="emptyCon">
          <div className="emptyIntCon text-center">
            <div className="paddingBox">
              <div className="icon-holder">
                <FontAwesome name="exclamation-circle" size="5x" />
              </div>
              The MLM is not currently configured to receive data from this
              device. For more information, please contact a member of the MLM
              team.
            </div>
          </div>
        </div>
      );
    }

    if (this.state.formError) {
      return (
        <div className="emptyCon">
          <div className="emptyIntCon text-center">
            <div className="paddingBox">
              <div className="icon-holder">
                <FontAwesome name="exclamation-circle" size="5x" />
              </div>
              The MLM is not currently configured to receive data for these
              combinations. Please fix the error or for more information,
              contact a member of the MLM team.
            </div>
          </div>
        </div>
      );
    }

    if (sensorDataList.length > 0 && deviceDetails) {
      return (
        <div>
          <LineGraph height={500} isDetailPage={true} />
          <div className="download-panel pull-right">
            <a className="link" onClick={this.downloadData}>
              <FontAwesome name="download" /> Download CSV
            </a>
          </div>
        </div>
      );
    }
  };

  renderMainContent = deviceDetails => {
    if (!deviceDetails) {
      return null;
    }

    return (
      <div className="mainContent">
        <Row className="row-eq-height">
          <Col md={3} sm={12}>
            <div className="panel-div device-summary-panel">
              <h3>Device Summary</h3>
              {this.renderStatus(deviceDetails)}
              <div className="datum">
                <span className="datum-name">Device Type</span>
                <span className="datum-value">
                  {deviceDetails.device_type_display}
                </span>
              </div>
              <div className="datum">
                <span className="datum-name">Discipline</span>
                <span className="datum-value">
                  {this.getSensorType(deviceDetails.disciplines)}
                </span>
              </div>
              <div className="datum">
                <span className="datum-name">Precinct</span>
                <span className="datum-value">
                  {this.getPrecincts(deviceDetails.precincts)}
                </span>
              </div>
              <div className="device-map">
                {this.renderTheDeviceLocationOnMap(deviceDetails)}
              </div>
            </div>
          </Col>
          <Col md={9} sm={12}>
            <div className="panel-div device-graph-panel noPadding">
              <div
                className={
                  "left-panel" + (this.state.filterOpen ? " filterOpen" : "")
                }
              >
                <h3>
                  Device Data{" "}
                  {this.state.dataTruncated ? (
                    <span className="data-truncated pull-right">
                      Data requested is too large and has been truncated
                    </span>
                  ) : null}
                </h3>
                {this.renderDeviceGraph()}
              </div>
              <div
                className={
                  "right-panel" + (this.state.filterOpen ? " filterOpen" : "")
                }
              >
                <h3>Filter Device Data {this.renderResetBtn()}</h3>
                {this.renderGraphFilter()}
              </div>
            </div>
          </Col>
          <Col md={12} sm={12}>
            <div
              className={
                "buttonContainer margin-btm filter-btn-con" +
                (this.state.filterOpen ? " filterOpen" : "")
              }
            >
              <Button
                type="button"
                onClick={() => this.openFilter(true)}
                bsStyle="primary"
              >
                Filter Device Data
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render = () => {
    const { deviceDetails } = this.state;

    if (deviceDetails) {
      return (
        <div className="newDeviceView">
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderTitlePanel(deviceDetails)}
              {this.renderMainContent(deviceDetails)}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  };
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    user,
    configList
  };
}

export default connect(mapStateToProps, {
  sensorId,
  getSensorData,
  filteredSensorDataList,
  sidebarOff,
  pageDevices,
  modalAlert,
  setTelemetryAlertData
})(ViewDevicePage);



// WEBPACK FOOTER //
// ./src/_components/ViewDevicePage/index.js